module.exports = __webpack_public_path__ + "img/skull_9_bj.24ede4ed.png";